/**
 * Frontend mirror of `backend/services/email_validator.py`.
 * Keep the rules in sync — both files must reject the same set of fake/test
 * addresses so the UI can show the inline error BEFORE the request is sent.
 *
 * Whitelist: `@test.com` and `@demo.com` are intentionally allowed (real
 * domains used by sales demos & E2E). Only block patterns that are
 * structurally undeliverable.
 */

const RFC_EMAIL = /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/;

const BLOCKED_DOMAINS = new Set([
  'a.c', 'd.c', 'b.c', 'c.c',
  'test.test', 'mail.mail', 'deneme.deneme', 'asd.asd', 'qq.qq', 'q.q',
  'example', 'example.c', 'example.x',
  'invalid', 'invalid.c',
  'localhost', 'local',
]);

const BLOCKED_EXACT = new Set([
  'test@test', 'mail@mail', 'deneme@deneme', 'asd@asd',
  'a@a', 'b@b', 'q@q', 'x@x',
]);

const BLOCKED_TLD = new Set(['local', 'localhost', 'example', 'test', 'invalid']);

export const EMAIL_ERROR_TR = 'Lütfen geçerli bir e-posta adresi girin.';

/** Returns true when the email is syntactically valid AND not on a known
 *  placeholder/non-deliverable list. Empty/null input returns false. */
export const isValidBusinessEmail = (value) => {
  if (typeof value !== 'string') return false;
  const e = value.trim().toLowerCase();
  if (!e || !e.includes('@')) return false;
  const [local, domain] = e.split('@');
  if (!local || !domain || !domain.includes('.')) return false;
  const tld = domain.split('.').pop();
  if (!tld || tld.length < 2) return false;
  if (!RFC_EMAIL.test(e)) return false;
  if (BLOCKED_EXACT.has(e)) return false;
  if (BLOCKED_DOMAINS.has(domain)) return false;
  if (BLOCKED_TLD.has(tld)) return false;
  return true;
};
